/**
 * Load the editor's HTML.
 */
export default async function wrapHtmlLoader(value: string) {
  return value;
}
